export default __webpack_public_path__ + "media/images/home/latest-project-black-holes.jpg";